var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        { attrs: { id: "icon/check", "clip-path": "url(#clip0_875_25706)" } },
        [
          _c("path", {
            attrs: {
              id: "Vector",
              d: "M15.3569 3.12451L5.92829 15.1245L1.64258 9.66997",
              stroke: "#F9F9F9",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_875_25706" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0.5 0.942871)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }